import api from './clients';
import { Envio, EnvioFormData, EnvioStats } from '../types/envio';
import { buildQueryString } from '../lib/pagination';

interface GetEnviosParams {
  search?: string;
  estado?: string;
  incluirOcultos?: string;
  page?: number;
  limit?: number;
}

export const enviosApi = {
  getAll: async (params?: GetEnviosParams) => {
    const query = buildQueryString({
      search: params?.search,
      estado: params?.estado,
      incluirOcultos: params?.incluirOcultos,
      page: params?.page,
      limit: params?.limit,
    });

    const response = await api.get(`/envios${query}`);
    return response.data;
  },

  getById: async (id: number): Promise<Envio> => {
    const response = await api.get(`/envios/${id}`);
    return response.data?.data;
  },

  create: async (data: EnvioFormData): Promise<Envio> => {
    const response = await api.post('/envios', data);
    return response.data?.data;
  },

  update: async (id: number, data: Partial<EnvioFormData>): Promise<Envio> => {
    const response = await api.put(`/envios/${id}`, data);
    return response.data?.data;
  },

  ocultar: async (id: number): Promise<Envio> => {
    const response = await api.put(`/envios/${id}/ocultar`);
    return response.data?.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/envios/${id}`);
  },

  rastrear: async (codigo: string) => {
    const response = await api.get(`/envios/rastreo/${codigo}`);
    return response.data;
  },

  getStats: async (): Promise<EnvioStats> => {
    const response = await api.get('/envios/estadisticas');
    return response.data?.data;
  },
};